import { useConferenceStore } from '@/store/ConferenceStore.ts';
import { useDeviceStore } from '@/store/DeviceStore.ts';
import { ScreenListener } from 'mind-sdk-web';
import { Participant } from 'mind-sdk-web/lib/Participant';

export class ScreenEventListener extends ScreenListener {
  constructor() {
    super();
  }

  onScreenReleasedForcibly() {
    const me = useConferenceStore.getState().session?.getConference()?.getMe();
    useConferenceStore.getState().session?.fireOnParticipantSecondaryMediaChanged(me as Participant);

    useDeviceStore.getState().setScreenPresentingEnabled(false);
  }
}
